import { useI18n } from '../i18n/useI18n';
import { privacyAssets } from '../data/websiteAssets';

export function PrivacySection() {
  const { language, t } = useI18n();
  const image = privacyAssets.get(language);

  return (
    <section className="section split-section" id="privacy">
      <div>
        <p className="eyebrow">{t('privacy.eyebrow')}</p>
        <h2>{t('privacy.title')}</h2>
        <p>{t('privacy.text')}</p>
        <p className="section-note">{t('privacy.note')}</p>
      </div>
      <picture className="section-visual privacy-visual">
        <source srcSet={image.webp} type="image/webp" />
        <img src={image.png} alt={t('privacy.visualAlt')} loading="lazy" width="1672" height="941" />
      </picture>
    </section>
  );
}
